<template>
  <header class="bg-white shadow-lg border-b border-slate-200 sticky top-0 z-30">
    <div class="flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
      <!-- Mobile menu button -->
      <div class="flex items-center space-x-4">
        <button
          @click="$emit('toggle-sidebar')"
          class="lg:hidden p-2 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors duration-200"
        >
          <MenuIcon class="h-6 w-6" />
        </button>
        <!-- Mobile title -->
        <div class="sm:hidden">
          <h1 class="text-lg font-bold text-slate-900">Dashboard</h1>
        </div>
      </div>
      <!-- Right side -->
      <div class="flex items-center space-x-4">
        <!-- Search bar (hidden on mobile) -->
        <div class="hidden md:block relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <SearchIcon class="h-5 w-5 text-slate-400" />
          </div>
          <input
            v-model="searchQuery"
            @focus="searchResultsVisible = true"
            @blur="setTimeout(() => searchResultsVisible = false, 200)"
            type="text"
            placeholder="Search..."
            class="block w-64 pl-10 pr-3 py-2 border border-slate-300 rounded-lg leading-5 bg-white placeholder-slate-500 focus:outline-none focus:placeholder-slate-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
          />
          <!-- Dropdown for filtered results -->
          <ul
            v-if="searchResultsVisible && filteredSchools.length"
            class="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg"
          >
            <li
              v-for="(school, index) in filteredSchools"
              :key="index"
              @click="selectSchool(school)"
              class="px-4 py-2 hover:bg-slate-100 cursor-pointer"
            >
              {{ school }}
            </li>
          </ul>
        </div>
        <!-- Notifications -->
        <button
          class="relative p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors duration-200"
        >
          <BellIcon class="h-6 w-6" />
          <span class="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500"></span>
        </button>
        <!-- Admin Avatar Dropdown -->
        <div class="relative">
          <button
            @click="dropdownOpen = !dropdownOpen"
            class="flex items-center space-x-3 rounded-lg bg-white p-2 text-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200"
          >
            <img
              class="h-8 w-8 rounded-full ring-2 ring-blue-500"
              src="https://vue-demo.tailadmin.com/images/user/owner.jpg"
              alt="Admin Avatar"
            />
            <span class="hidden md:block text-sm font-medium text-slate-700">Institute admin</span>
            <ChevronDownIcon class="h-4 w-4 text-slate-400" />
          </button>

          <!-- Dropdown menu -->
          <div
            v-if="dropdownOpen"
            class="absolute right-0 mt-2 w-48 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
          >
            <div class="py-1">
              <a href="#" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors duration-200">Your Profile</a>
              <a href="#" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors duration-200">Settings</a>
              <a href="#" class="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors duration-200">Sign out</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script setup>
import { BellIcon, MenuIcon, SearchIcon, ChevronDownIcon } from 'lucide-vue-next';
import { ref, computed } from 'vue';
defineEmits(['toggle-sidebar']);
const dropdownOpen = ref(false);
// Search logic
const searchQuery = ref('');
const searchResultsVisible = ref(false);
const schools = ref([
  'Greenwood High School',
  'Metropolitan College',
  'Sunrise Academy',
  'Tech University',
  'Riverside Elementary',
  'Amphary High School'

]);
const filteredSchools = computed(() => {
  if (!searchQuery.value) return [];
  return schools.value.filter(school =>
    school.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});
const selectSchool = (school) => {
  searchQuery.value = school;
  searchResultsVisible.value = false;  
};
</script>
